export const PROSPECTUS_LOCALE_COOKIE = "prod-edx-language-preference";

export const LOCALE_TO_COOKIE_MAP: Record<string, string> = {
  es: "es-419",
  en: "en",
} as const;
